import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes, provideRouter } from '@angular/router';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import { FeedDetailsViewComponent } from './shared/components/feed-details-view/feed-details-view.component';
import { HealthcheckAndInfoComponent } from './shared/components/healthcheck-and-info/healthcheck-and-info.component';

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  { path: 'login', loadComponent: () => import('./features/login/login-home/login-home.component').then(c => c.LoginHomeComponent) },
  { path: 'logout', loadComponent: () => import('./features/login/logout/logout.component').then(c => c.LogoutComponent) },
  { path: 'forgot-password', loadComponent: () => import('./features/login/forgot-password/forgot-password.component').then(c => c.ForgotPasswordComponent) },
  { path: 'reset-password', loadComponent: () => import('./features/login/reset-password/reset-password.component').then(c => c.ResetPasswordComponent) },
  { path: 'accounts', canActivate: [AuthGuard], loadChildren: () => import('./features/accounts/accounts.module').then(x => x.AccountsModule) },
  { path: 'account/project', canActivate: [AuthGuard], loadChildren: () => import('./features/projects/projects.module').then(x => x.ProjectsModule) },
  { path: 'adminconsole', canActivate: [AuthGuard], loadComponent: () => import('./features/admin/admin-home/admin-home.component').then(c => c.AdminHomeComponent) },
  {
    path: 'billing',
    canActivate: [AuthGuard],
    loadChildren: () => import('./features/billing/billing.module').then((m) => m.BillingModule),
  },
  { path: 'feed', component: FeedDetailsViewComponent },
  { path: 'healthcheck', component: HealthcheckAndInfoComponent },
  { path: 'interaction/preview', loadComponent: () => import('./features/projects/settings/project-interaction-settings-home/sub-components/litmus-intraction-preview/litmus-intraction-preview.component').then(c => c.LitmusIntractionPreviewComponent) },

  { path: '**', component: PageNotFoundComponent }
]

// export const routing = RouterModule.forRoot(appRoutes)

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
